export { Cell } from './Cell';
export { Row, Rows } from './Row';
export { Col } from './Cols';
export { TableWrapper, Table } from './TableWrapper';
export const sum = arr => arr.reduce((acc, n) => acc + n, 0);
